import { Component } from '@angular/core';

@Component({
    selector: 'app-page-sidebar',
    templateUrl: './page-sidebar.component.html',
    styleUrls: ['./page-sidebar.component.scss']
})
export class PageSidebarComponent {
}
